// Native Shopify content pages share the approved navigation without loading
// the React storefront or intercepting Shopify's contact-form submission.
(() => {
  const active = new WeakMap();
  function initialise(scope) {
    const roots = scope.matches?.('[data-fortuna-content-shell]') ? [scope] : scope.querySelectorAll('[data-fortuna-content-shell]');
    for (const root of roots) {
      if (active.has(root)) continue;
      const controller = new AbortController();
      active.set(root, controller);
      const options = { signal: controller.signal };
      root.querySelectorAll('.fortuna-whatsapp-badge-link').forEach(link => {
        link.addEventListener('click', event => event.stopPropagation(), { ...options, capture: true });
      });
      const menuButton = root.querySelector('[data-menu-toggle]');
      const nav = root.querySelector('[data-main-nav]');
      const shopRoot = root.querySelector('[data-shop-menu]');
      const shopButton = root.querySelector('[data-shop-toggle]');
      const panel = root.querySelector('[data-shop-panel]');
      const openIcon = menuButton.querySelector('[data-menu-open-icon]');
      const closeIcon = menuButton.querySelector('[data-menu-close-icon]');
      let closeTimer;
      const drawer = () => getComputedStyle(menuButton).display !== 'none';
      const setShop = (open) => {
        clearTimeout(closeTimer);
        shopButton.setAttribute('aria-expanded', String(open));
        panel.hidden = !open;
      };
      const setMenu = (open, focus = false) => {
        menuButton.setAttribute('aria-expanded', String(open));
        nav.classList.toggle('is-mobile-open', open);
        openIcon.hidden = open;
        closeIcon.hidden = !open;
        menuButton.setAttribute('aria-label', open ? menuButton.dataset.labelClose : menuButton.dataset.labelOpen);
        if (focus) menuButton.focus();
      };
      menuButton.addEventListener('click', () => {
        setShop(false);
        setMenu(menuButton.getAttribute('aria-expanded') !== 'true');
      }, options);
      shopButton.addEventListener('click', () => setShop(panel.hidden), options);
      nav.addEventListener('click', event => {
        if (!event.target.closest('a')) return;
        setShop(false);
        setMenu(false);
      }, options);
      shopRoot.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse' && !drawer()) setShop(true);
      }, options);
      shopRoot.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse' && !drawer()) closeTimer = setTimeout(() => setShop(false), 160);
      }, options);
      shopRoot.addEventListener('focusout', event => {
        if (!shopRoot.contains(event.relatedTarget) && !nav.contains(event.relatedTarget)) setShop(false);
      }, options);
      document.addEventListener('pointerdown', event => {
        if (!shopRoot.contains(event.target) && !nav.contains(event.target)) setShop(false);
      }, options);
      document.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        if (!panel.hidden) { setShop(false); shopButton.focus(); }
        else if (menuButton.getAttribute('aria-expanded') === 'true') setMenu(false, true);
      }, options);
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(root)) return;
        clearTimeout(closeTimer);
        controller.abort();
        active.delete(root);
      }, options);
    }
  }
  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
